import { Transaction, TransactionByUser } from '../transaction/types';

export const getLastTransaction = (subscriptionId: string, transactions?: Transaction[] | TransactionByUser[]) => {
  return transactions?.find(transaction => transaction.subscriptionId === subscriptionId);
};
